<template>
	<div class="settings-container">
		<div class="settings-controls">
			<button @click="state.currentPanel = 'chat'" class="button button-back">Готово</button>
		</div>

		<div class="settings-list">
			<div class="chat-settings-group" v-show="state.currentUser.id >= 0">
				<div class="chat-settings-title">Аккаунт</div>

				<div>Логин: {{ state.currentUser.login }}</div>
				<div>
					Чтобы залогиниться или зарегистрироваться,
					<a :href="`//${state.baseDomain}/login`" target="_blank">воспользуйтесь формой на основном сайте</a>,
					после чего перезагрузите страницу с чатом
				</div>
			</div>

			<!--div class="chat-settings-group" v-show="state.currentUser.id <= 0">
				<div class="chat-settings-title">Аккаунт</div>

				<InputField name="login" title="Логин" v-model="account.login"/>
				<InputField name="password" type="password" title="Пароль" v-model="account.password"/>
				<div><a href="//sinair.ru/register" target="_blank">Нет аккаунта? Зарегистрируйся!</a></div>
				<button class="button" @click="login" :disabled="disabled.login">Войти</button>
			</div>

			<div class="chat-settings-group" v-show="state.currentUser.id >= 0">
				<div class="chat-settings-title">Аккаунт</div>

				<div>Логин: {{ state.currentUser.login }}</div>
				<button class="button" @click="logout" :disabled="disabled.logout">Выйти</button>
			</div-->

			<div class="chat-settings-group">
				<div class="chat-settings-title">Поведение</div>

				<CheckBox name="confirmPageClose" v-model="settings.confirmPageClose" title="Спрашивать подтверждение закрытия вкладки с чатом"/>
				<CheckBox name="statusMessages" v-model="settings.statusMessages" title="Показывать в чате сообщения о подключении/отключении пользователей в комнате"/>
			</div>

			<div class="chat-settings-group">
				<div class="chat-settings-title">Внешний вид</div>

				<RadioList
					name="messagesStyle"
					title="Стиль сообщений"
					hint="Привет, Discord"
					v-model="settings.messagesStyle"
					:values="[
						{value: 'cozy', description: 'Уютный (beta)'},
						{value: 'compact', description: 'Компактный'},
					]"/>
			</div>

			<div class="chat-settings-group">
				<div class="chat-settings-title">Уведомления</div>

				<CheckBox name="sound" v-model="settings.sound" title="Звуковые уведомления"/>
				<CheckBox name="icon" v-model="settings.icon" title="Мигание иконки в заголовке страницы"/>
				<CheckBox name="mention" v-model="settings.mention" title="Всплывающие уведомления при @упоминаниях в чате"/>
				<CheckBox name="typing" v-model="settings.typing" title="Индикация набора сообщения (вами и участниками чата)"/>
				<CheckBox name="statusMessageNotifications"
					v-model="settings.statusMessageNotifications"
					title="Звуковое уведомление при подключении/отключении пользователей в комнате"
					/>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import eventBus from '../eventbus';
import RadioList from './options/RadioList.vue';
import CheckBox from './options/CheckBox.vue';
import InputField from './options/InputField.vue';

export default {
	components: {
		RadioList,
		CheckBox,
		InputField,
	},

	data(){
		return {
			state: eventBus.state,
			account: {
				login: '',
				password: '',
			},
			disabled: {
				login: false,
				logout: false,
			}
		};
	},

	computed: {
		settings() {
			return this.state.settings;
		},
	},

	methods: {
		/*login(e) {
			// TODO: авторизоваться в чате, в state передаются не те данные, они должны идти от сервера чата
			this.disabled.login = true;
			// TODO: домен
			axios.post(`//${this.state.baseDomain}/fapi/login`, {
				login: this.account.login,
				password: this.account.password,
			})
			.then((response) => {
				this.disabled.login = false;
				if (response.status == 200) {
					let data = response.data;
					if (data.code == 0) {
						this.account.password = '';
						this.state.currentUser = {
							id: data.id,
							login: data.login,
						};
					} else {
						alert('Неверный логин или пароль');
					}
				} else {
					console.log(response);
					alert('Неожиданный ответ от сервера при авторизации. Свяжитесь с разработчиком.');
				}
			})
			.catch((err) => {
				console.error(err);
				this.disabled.login = false;
				alert('Возникла ошибка при авторизации. Попробуйте еще раз.');
			});
		},

		logout(e) {
			this.disabled.logout = true;
			// TODO: домен
			axios.post(`//${this.state.baseDomain}/fapi/logout`, {})
			.then((response) => {
				this.disabled.logout = false;
				if (response.status == 200) {
					this.state.currentUser = {
						id: 0,
						login: 'Гость',
					};
				} else {
					console.log(response);
					alert('Неожиданный ответ от сервера при выходе из аккаунта. Свяжитесь с разработчиком.');
				}
			})
			.catch((err) => {
				console.error(err);
				this.disabled.logout = false;
				alert('Возникла ошибка при выходе из аккаунта. Попробуйте еще раз.');
			});
		},*/
	},

	watch: {
		'settings.mention'(val) {
			if (val && !this.settings.isNotificationPermissionGranted() && Notification !== undefined){
				Notification.requestPermission();
			}
		},
	},
}
</script>

<style lang="less" scoped>
@import (reference) "~@/css/chat.less";

.settings-container {
	padding: 10px;
	background-color: @color-chat-3;
}

.settings-controls {
	margin-bottom: 10px;
	text-align: center;
}

.button-back {
	width: 100%;
	max-width: 300px;
}

.settings-list {
	display: flex;
	flex-direction: column;

	> * {
		margin: 5px 0;
	}
}

.chat-settings-group {
	background-color: @color-chat-4;
	border-radius: 2px;
	padding: 10px 10px 10px 20px;

	> * {
		margin-top: 10px;
	}

	> .chat-settings-title {
		margin: 0 0 0 -10px;
		font-weight: bold;
	}
}

.button {
	padding: 8px 20px;
	border: none;
	border-radius: 2px;
	cursor: pointer;
	background-color: @color-chat-5;

	font-family: @font-main;
	font-size: @font-size-main;
	color: @font-color-main;

	&:hover {
		background-color: @color-chat-6;
	}

	&:active {
		background-color: @color-chat-4;
	}
}

@media (min-width: @mobile-width) {
	.settings-list {
		flex-direction: row;
		flex-wrap: wrap;
		align-items: flex-start;
		align-content: flex-start;

		> * {
			min-height: 160px;
			max-width: 500px;
			margin: 5px;
		}
	}

	.settings-controls {
		text-align: left;
	}
}
</style>
